import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';

import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    fontRoboto: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
    },

    consoleHeaderTB: {
      fontWeight: 500,
      fontSize: '22px',
      height: '50px',
      color: '#FFFFFF',
      marginTop: '14px',
    },

    pageHeaderTB: {
      display: 'block',
      height: '28px',
      fontWeight: 500,
      fontSize: '20px',
      lineHeight: '28px',
      color: '#000000',
      margin: '0',
      padding: '0',
    },

    userNameTB: {
      width: '88px',
      height: '20px',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '20px',
      color: '#FFFFFF',
      margin: '0',
      padding: '0',
    },

    titleConfirmModalTB: {
      width: '380px',
      height: '24px',
      fontWeight: 500,
      fontSize: '17px',
      lineHeight: '24px',
      color: '#000000ED',
    },

    textConfirmModalTB: {
      width: '400px',
      height: '60px',
      color: '#000000A1',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      margin: 0,
      whiteSpace: 'pre-line',
    },

    titleErrorModalTB: {
      width: '380px',
      height: '24px',
      fontWeight: 500,
      fontSize: '17px',
      lineHeight: '24px',
      color: '#000000ED',
    },

    textErrorModalTB: {
      width: '400px',
      height: '40px',
      color: '#000000A1',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      margin: 0,
    },

    fileUploadModalTB: {
      height: '20px',
      color: '#000000A1',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      margin: 0,
    },

    fileUploadTitleModalTB: {
      height: '24px',
      fontWeight: 500,
      fontSize: '17px',
      lineHeight: '24px',
      color: '#000000ED',
    },

    alignCenterTB: {
      textAlign: 'center',
    },

    leftFloat: {
      float: 'left',
    },
  },
  {
    name: 'TextBlock',
  },
);
